import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";

import { Button } from "@mui/material";

import {
  Dialog,
  DialogBody,
  DialogFeet,
  DialogHead,
  DialogProps,
} from "@/components/dialogs";
import { Preloader } from "@/primitives";

import { ComposeForm } from "./ComposeForm";

export const ComposeDialog: React.FC<
  DialogProps & { close: () => void; isComposing: boolean }
> = ({ close, isComposing, ...props }) => {
  const { t } = useTranslation();
  const { isValid, handleSubmit } = useFormikContext();

  return (
    <Dialog close={close} {...props}>
      {isComposing ? (
        <>
          <DialogHead
            title={t("app.flows.compose.composingTitle")}
            text={t("app.flows.compose.composingText")}
          />
          <DialogBody>
            <Preloader />
          </DialogBody>
          <DialogFeet>
            <Button fullWidth onClick={close} size="large" variant="contained">
              {t("common.close")}
            </Button>
          </DialogFeet>
        </>
      ) : (
        <>
          <DialogHead
            title={t("app.flows.compose.composeTitle")}
            text={t("app.flows.compose.composeText")}
          />
          <DialogBody>
            <ComposeForm />
          </DialogBody>
          <DialogFeet>
            <Button size="large" fullWidth variant="outlined" onClick={close}>
              {t("common.cancel")}
            </Button>
            <Button
              disabled={!isValid}
              fullWidth
              size="large"
              onClick={() => handleSubmit()}
              variant="contained"
            >
              {t("app.flows.compose.composeButton")}
            </Button>
          </DialogFeet>
        </>
      )}
    </Dialog>
  );
};
